import { createFeatureSelector, createSelector } from '@ngrx/store';
import { topicFeatureKey, State } from '../reducers/topic.reducer';

const selectTopicState = createFeatureSelector<State>(topicFeatureKey);

export const getTopic = createSelector(selectTopicState, state => state.getTopicResult);
